module.exports = __webpack_public_path__ + "static/media/support-Doreen_Parsons-Smith.0659514b.jpg";